import { Link } from "react-router-dom";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-label tracking-[0.25em] text-accent-700">
            <span className="h-px w-6 bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">{description}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}